import { $color, $shadow } from "@/utils/cssVarUtils"
import { drawerAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  PartsStyleObject,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { Modal } from './modal'

/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */
function getSize(value: string): PartsStyleObject<typeof parts> {
  if (value === "full") {
    return {
      dialog: { maxW: "100vw", h: "100vh" },
    }
  }
  return {
    dialog: { maxW: value },
  }
}

const baseStyleOverlay: SystemStyleObject = {
  bg: "blackAlpha.600",
  zIndex: "overlay",
}

const baseStyleDialogContainer: SystemStyleObject = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center",
}

const baseStyleDialog: SystemStyleFunction = (props) => {
  const { isFullHeight } = props

  return {
    ...(isFullHeight && { height: "100vh" }),
    zIndex: "modal",
    maxH: "100vh",
    bg: $color('bg-tooltip-normal'),
    color: "inherit",
    boxShadow: $shadow('normal'),
  }
}

const baseStyleHeader: SystemStyleFunction = (props) => {

  return {
    ...Modal.baseStyle(props).header,
    textAlign: 'left',
  }
}

const baseStyleCloseButton: SystemStyleFunction = (props) => {
  return {
    ...Modal.baseStyle(props).closeButton,
  }
}

const baseStyleBody: SystemStyleObject = {
  p: 'md',
  flex: 1,
  overflow: "auto",
}

const baseStyleFooter: SystemStyleObject = {
  p: 'md',
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer,
  dialog: baseStyleDialog(props),
  header: baseStyleHeader(props),
  closeButton: baseStyleCloseButton(props),
  body: baseStyleBody,
  footer: baseStyleFooter,
})

const sizes = {
  xs: getSize("container.xs"),
  sm: getSize("container.md"),
  md: getSize("container.lg"),
  lg: getSize("container.2xl"),
  xl: getSize("container.4xl"),
  full: getSize("container.full"),
}

const defaultProps = {
  size: "md",
}

export const Drawer = {
  parts: parts.keys,
  baseStyle,
  sizes,
  defaultProps,
}